<template>
	<div class="layout">
		<div class="tool-box">
			<div class="tool-box-title">
				<img src="/static/imgs/danju.png" class="jxyd-imgicon" />
				操作商品盘点单
			</div>
			<button class="jxyd-button jxyd-primary" title="审核" @click="dataSubmitAndCheck"
				v-show="permission.isAudit && documentItem.checkState == 1">
				<Icon type="md-checkbox-outline" size='18' />
				审核
			</button>
			<button class="jxyd-button" title="回滚" @click="rollback([documentItem.id])"
				v-show="permission.isRollback && documentItem.id > 0 && documentItem.checkState > 1">
				<Icon type="md-print" size='18' />
				回滚
			</button>
			<button class="jxyd-button" title="保存" @click="dataSubmit"
				v-show="permission.isEdit && documentItem.checkState == 1">
				<Icon type="md-bookmark" size='18' />
				保存
			</button>
			<button class="jxyd-button" title="打印" @click="printList" v-show="permission.isPrint">
				<Icon type="md-print" size='18' />
				打印
			</button>
		</div>
		<div>
			<div class="baseInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/jibenxinxi.png" class="jxyd-imgicon" />
						基本信息
					</div>
					<div class="layout-title-right">
					</div>
				</div>

				<table class="baseinfo-table">
					<tr>
						<td class="key">
							单据编号
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input readonly="readonly" v-model="documentItem.code" type="text" placeholder="请输入单据编号"
								class="baseinfo-input" />
						</td>
						<td class="key">
							业务日期
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td style="width:35%;">
							<input v-model="documentItem.businessDate" type="date" placeholder="请选择业务日期"
								class="baseinfo-input" />
						</td>
					</tr>

					<tr>
						<td class="key">
							业务员
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" v-model="documentItem.userId" filterable clearable>
								<Option v-for="item in userList" placeholder="请选择业务员" :value="item.id" :key="item.id">
									{{item.userDisplayName}}
								</Option>
							</Select>
						</td>
						<td class="key">
							仓库
							<font color="red" style="position:relative; top:5px;font-weight:bold;font-size: 20px">*
							</font>
						</td>
						<td class="selectBox">
							<Select size="small" @on-change="depotChange" v-model="documentItem.depotId" filterable
								clearable>
								<Option v-for="item in depotList" :value="item.id" :key="item.id">
									{{ item.depotName }}
								</Option>
							</Select>
						</td>
					</tr>
					<tr>
						<td class="key">
							备注
						</td>
						<td style="text-align: left;">
							<input type="textarea" v-model="documentItem.note" placeholder="请输入备注"
								class="baseinfo-input">
						</td>
					</tr>
				</table>
			</div>
			<div class="commodityInfo">
				<div class="modal-title">
					<div class="layout-title-left">
						<img src="/static/imgs/shangpin.png" class="jxyd-imgicon" />
						商品信息
					</div>
					<div class="layout-title-right">
						<SelectSKUModal ref="selectCommodityModal" @getResult="data=>{this.commoditySelected = data;}"
							:selectedCommodity="commoditySelected" :selectedBeforeCheck="selectedSKUCheck">
						</SelectSKUModal>
						<SelectSKUByCodeModal ref="selectCommodityModal"
							@submitSelected="data=>{this.commoditySelected = data;}"
							:commoditySelected="commoditySelected" :selectedBeforeCheck="selectedSKUCheck">
						</SelectSKUByCodeModal>
					</div>
				</div>
				<Table stripe :columns="commodityColumn" :data="documentItem.inventorySheetDetailLists"></Table>
			</div>
			<div class="file">
				<div class="modal-title" style="border-bottom: 1px solid #e8eaec;">
					<div class="layout-title-left">
						<Icon type="ios-link" size='20' color='#bd10e0' />
						单据附件
					</div>
					<div class="layout-title-right">
					</div>
				</div>
				<div style="padding:15px 10px;">
					<DocumentFile :isShow='false' :fileList.sync='documentItem.fileList'
						:actionPath='"/file/file/UploadFile"'></DocumentFile>
				</div>
			</div>
			<div id="voucher-bottomBar">
				<table style="float: left;">
					<tr>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">盈亏总额：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.lossAmount}}</span>
						</td>
						<td style="border-right:1px solid #DCDFE6;padding-right:15px;">
							<span style="font-size: 16px;font-weight: bold;color: var(--font1Color);">盈亏总数：</span>
							<span style="color: #ff4d4d;font-size: 22px;">￥{{documentItem.lossQuantity}}</span>
						</td>
					</tr>
				</table>
			</div>
			<div class="billStateCls" v-show="documentItem.checkState == 2"><span>已审核</span></div>
			<div class="billStateCls" v-show="documentItem.checkState == 3"><span>已完结</span></div>
			<!-- 使用封装的自定义抽屉组件 -->
			<CustomDrawer v-model="batchCodeListModal" :title="`盘点批次库存`" :width="700" placement="right" :mask="true"
				:mask-closable="true" :closable="true">
				<template #title>
					<div class="drawer-title">
						<div class="drawer-title-left">
							<Icon type="ios-search" :size='18' />
							盘点批次库存
						</div>
						<div class="drawer-title-right"></div>
					</div>
				</template>
				<div class="drawer-content">
					<Table :height='pageHeight' disabled-hover :columns="batchCodeListColumn"
						:data="getBatchCodeDetails">
					</Table>
				</div>
				<template #footer>
					<div class="selected-sku">
						<!-- <Icon type="md-cart" size='20' />
						<Badge :count="getCurrentCommodityQuantity">
							<span>合计:&nbsp;¥{{getCurrentCommodityAmount}}</span>
						</Badge> -->
					</div>
					<button class="jxyd-button jxyd-primary" type="primary" @click="batchCodeListModal = false">确定</button>
				</template>
			</CustomDrawer>
		</div>
	</div>
</template>

<script>
	import request from '@/utils/request'
	import formatNum from '@/utils/formatNum'
	import SelectSKUModal from '@/components/SelectSKUModal'
	import SelectSKUByCodeModal from '@/components/SelectSKUByCodeModal'
	import formatDate from '@/utils/formatDate'
	import dateUtil from '@/utils/dateUtil'
	import DocumentFile from '@/components/DocumentFile'
	import CustomDrawer from '@/components/CustomDrawer' // 导入自定义抽屉组件

	export default {
		name: 'inventorysheetfunc',
		components: {
			SelectSKUModal,
			DocumentFile,
			SelectSKUByCodeModal,
			CustomDrawer
		},
		computed: {
			getBatchCodeDetails() {
				if (this.batchCodeIndex > -1 && this.documentItem.inventorySheetDetailLists.length>0) {
					return this.documentItem.inventorySheetDetailLists[this.batchCodeIndex].inventorySheetBatchCodeDetails;
				}
				return [];
			},
			selectedSKUCheck() {
				if (!this.documentItem.depotId) {
					return "请先选择盘点仓库!";
				}
				return "";
			},
			commoditySelected: {
				get() {
					let data = [];
					this.documentItem.inventorySheetDetailLists.forEach(item => {
						data.push(item.priceTypeData);
					});
					return data;
				},
				set(newValue) {
					this.documentItem.inventorySheetDetailLists = [];
					for (let i = 0; i < newValue.length; i++) {
						let format = newValue[i].commodityPriceTypeGroup.groupName + ',' + newValue[i]
							.priceType;
						let batchCodeDetail = this.formatBatchCodeDetail(newValue[i], format);
						let stock = this.getCommodityTypeStock(newValue[i], format, newValue[i].commodityPriceTypeGroup
							.commodity.unit);
						this.documentItem.inventorySheetDetailLists.push({
							format: format,
							commodityId:newValue[i].commodityPriceTypeGroup.commodity.id,
							deficiency: newValue[i].deficiency ? newValue[i].deficiency : 0,
							accountBalance: stock,
							actualNumbers: newValue[i].actualNumbers ? newValue[i].actualNumbers : stock,
							inventorySheetBatchCodeDetails: batchCodeDetail,
							price: newValue[i].price ? newValue[i].price : newValue[i].intoPrice,
							unit: newValue[i].commodityPriceTypeGroup.commodity.unit,
							lossAmount: newValue[i].lossAmount ? newValue[i].lossAmount : 0,
							priceTypeData: newValue[i],
							note: newValue[i].note ? newValue[i].note : '',
						})
					}
				}
			}
		},
		data() {
			return {
				batchCodeListModal: false,
				batchCodeIndex: -1,
				batchCodeListColumn: [{
						title: '批次号',
						key: 'batchCode',
						width: 180
					},
					{
						title: '计量单位',
						key: 'unit',
						render: (h, params) => {
							return h('span', {}, this.documentItem.inventorySheetDetailLists[this.batchCodeIndex].unit);
						}
					},
					{
						title: '账存数',
						key: 'accountBalance'
					},
					{
						title: '实际数量',
						key: 'actualNumbers',
						width: 200,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.actualNumbers
								},
								style: {
									'width': '100%'
								},
								on: {
									'on-change': (val) => {
										let batchCodeItem = this.documentItem
											.inventorySheetDetailLists[this
												.batchCodeIndex].inventorySheetBatchCodeDetails[
												params.index];
										let price = this.documentItem.inventorySheetDetailLists[
											this
											.batchCodeIndex].price;
										batchCodeItem.actualNumbers = val;
										batchCodeItem.deficiency = formatNum(batchCodeItem
											.accountBalance - val);
										batchCodeItem.lossAmount = formatNum((batchCodeItem
											.accountBalance * price) - (val * price));
									}
								}
							})]
						}
					},
					{
						title: '盈亏数',
						key: 'deficiency'
					}
				],
				documentItem: {
					id: 0,
					code: '',
					businessDate: '',
					depotId: '',
					depotName: '',
					lossQuantity: 0,
					lossAmount: 0,
					inventorySheetDetailLists: [],
					userId: '',
					userDisplayName: '',
					creator: '0',
					note: '',
					checkState: 1, //未审核
					fileList: []
				},
				depotList: [],
				commodityColumn: [{
						title: '操作',
						key: 'action',
						width: 80,
						align: 'center',
						fixed: 'left',
						render: (h, params) => {
							return [h('Icon', {
								style: {
									cursor: 'pointer'
								},
								props: {
									type: 'md-trash',
									size: 24
								},
								on: {
									click: (e) => {
										this.documentItem.inventorySheetDetailLists.splice(params
											.index,
											1);
										this.commodityIds.splice(params.index, 1);
									}
								}
							})]
						}
					},
					{
						title: '商品',
						key: 'commodityName',
						fixed: 'left',
						width: 300,
						render: (h, params) => {
							return h('a', {
									class: 'jxyd-a',
									on: {
										click: (e) => {
											this.$router.push({
												path: 'commoditydetailinfo',
												query: {
													commodityId: params.row.priceTypeData
														.commodityPriceTypeGroup.commodity.id
												}
											});
										}
									}
								}, params.row.priceTypeData
								.commodityPriceTypeGroup.commodity.name);
						}
					},
					{
						title: '规格',
						key: 'format',
						width: 300,
					},
					{
						title: '计量单位',
						key: 'unit',
						width: 200,
						render: (h, params) => {
							return [h('Select', {
									props: {
										transfer: true,
										value: params.row.unit
									},
									on: {
										input: (val) => {
											this.documentItem.inventorySheetDetailLists[params.index]
												.unit = val;
											this.unitChange(params.index, val);
										}
									},
								},
								params.row.priceTypeData.commodityPriceTypeGroup.commodity.extraUnits.map(
									function(type) {
										return h('Option', {
											props: {
												value: type.unit,
												key: type.unit
											}
										}, type.unit);
									})
							)];
						}
					},
					{
						title: '帐存数量',
						key: 'accountBalance',
						width: 200
					},
					{
						title: '实际数量',
						key: 'actualNumbers',
						width: 200,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.actualNumbers
								},
								style: {
									'width': '100%'
								},
								on: {
									'input': (val) => {
										let detail = this.documentItem.inventorySheetDetailLists[params.index];
										detail.actualNumbers = val;
										detail.deficiency = formatNum(detail
											.accountBalance - val);
										detail.lossAmount = formatNum((detail
											.accountBalance * detail.price) - (val * detail.price));
									},
									'on-focus': (val) => {
										if (params.row.priceTypeData.commodityPriceTypeGroup
											.commodity.enableBatch) {
											// 使用防抖函数
											this.skuActualNumbersFocusDebounced(params.index);
										}
									}
								}
							})]
						}
					},
					{
						title: '单价',
						key: 'price',
						width: 200,
						render: (h, params) => {
							return [h('InputNumber', {
								attrs: {
									'min': 0,
									'value': params.row.price
								},
								style: {
									'width': '100%'
								},
								on: {
									input: (val) => {
										let detail = this.documentItem.inventorySheetDetailLists[params.index];
										detail.price = val;
										detail.lossAmount = formatNum((detail
											.accountBalance * detail.price) - (detail.actualNumbers * detail.price));
									}
								}
							})]
						}
					},
					{
						title: '盈亏数',
						key: 'deficiency',
						width: 200
					},
					{
						title: '盈亏额',
						key: 'lossAmount',
						width: 200
					},
					{
						title: '备注',
						key: 'note',
						width: 400,
					}
				],
				commodityIds: [],
				userList: [],
				permission: {
					isAdd: false,
					isEdit: false,
					isDelete: false,
					isAudit: false,
					isBatchAudit: false,
					isPrint: false,
					isRollback: false,
					isExport: false,
					isBatchPrint: false
				},
				debounceTimer: null,
				skuActualNumbersFocusDebounced: null,
				pageHeight: 0,
			}
		},

		methods: {
			// 防抖函数
			debounce(fn, delay) {
				return (...args) => {
					if (this.debounceTimer) clearTimeout(this.debounceTimer);
					this.debounceTimer = setTimeout(() => {
						fn.apply(this, args);
					}, delay);
				};
			},
			// 初始化防抖函数
			initDebounce() {
				this.skuActualNumbersFocusDebounced = this.debounce((index) => {
					this.skuActualNumbersFocus(index);
				}, 300);
			},
			skuActualNumbersFocus(index) {
				this.batchCodeIndex = index;
				this.batchCodeListModal = true;
			},
			unitChange(index, val) {
				let detail = this.documentItem.inventorySheetDetailLists[index];
				detail.price = this.getCommodityTypePrice(detail);
				detail.accountBalance = this.getCommodityTypeStock(detail.priceTypeData, detail.format, val);
				detail.actualNumbers = detail.accountBalance;
				detail.lossAmount = 0;
				detail.deficiency = 0;
				if (detail.inventorySheetBatchCodeDetails && detail.inventorySheetBatchCodeDetails.length > 0) {
					detail.inventorySheetBatchCodeDetails.forEach(item => {
						item.accountBalance = this.getCommodityTypeInventoryStock(detail.priceTypeData,detail.unit,item.batchCode, detail.format,
								item.sellByDate),
							item.actualNumbers = item.accountBalance;
						item.deficiency = 0;
						item.lossAmount = 0;
					})
				}
			},
			getCommodityTypeStock(priceTypeData, priceType, unit) {
				let stock = 0;
				let inventory = priceTypeData.commodityPriceTypeGroup.commodity.commodityInventorys.filter(m => m
					.depotId == this.documentItem.depotId && m
					.commodityPriceType == priceType);
				if (inventory) {
					stock = stock + inventory.reduce((sum, item) => sum + item.stock, 0);
				}
				const currentUnit = priceTypeData.commodityPriceTypeGroup.commodity.extraUnits.find(m => m.unit == unit);
				if (currentUnit) {
					stock = stock * currentUnit.conversionRate;
				}

				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getCommodityTypeInventoryStock(priceTypeData,unit,batchCode, priceType, sellbyDate) {
				let stock = 0;
				let inventory = priceTypeData.commodityPriceTypeGroup.commodity.commodityInventorys.filter(m => m
					.depotId == this.documentItem.depotId && m
					.commodityPriceType == priceType && m.batchCode == batchCode && m.sellByDate[1] == sellbyDate);
				if (inventory) {
					stock = stock + inventory.reduce((sum, item) => sum + item.stock, 0);
				}
				const currentUnit = priceTypeData.commodityPriceTypeGroup.commodity.extraUnits.find(m => m.unit == unit);
				if (currentUnit) {
					stock = stock * currentUnit.conversionRate;
				}

				if (stock && Number.isFinite(stock)) {
					return formatNum(stock);
				} else {
					return 0;
				}
			},
			getCommodityTypePrice(data) {
				const currentUnit = data.priceTypeData.commodityPriceTypeGroup.commodity.extraUnits.find(m => m.unit ==
					data.unit);
				if (currentUnit && data.priceTypeData) {
					let price = data.priceTypeData.intoPrice;
					return formatNum(price / currentUnit.conversionRate);
				}
				return 0;
			},
			emptyForm() {
				this.documentItem.id = 0
				this.documentItem.businessDate = formatDate(dateUtil.getCurrentDate(), 'yyyy-MM-dd')
				this.documentItem.inventorySheetDetailLists = []
				this.documentItem.lossQuantity = 0
				this.documentItem.lossAmount = 0
				this.documentItem.depotId = '';
				this.documentItem.userId = parseInt(localStorage.getItem("userId"));
				this.documentItem.userDisplayName = localStorage.getItem("userName");
				this.documentItem.creator = parseInt(localStorage.getItem("userId"));
				this.documentItem.note = ''
				this.documentItem.checkState = 1 //未审核
				this.documentItem.fileList = []
				this.getNextCode();
			},
			formatBatchCodeDetail(data, format) {
				let array = []
				if (data.commodityPriceTypeGroup.commodity.enableBatch) {
					if (data.commodityPriceTypeGroup.commodity.commodityInventorys) {
						let filterResult = data.commodityPriceTypeGroup.commodity.commodityInventorys
							.filter(m => m.depotId == this.documentItem.depotId &&
								m.commodityPriceType == format);
						array = this.groupAndSumData(filterResult);
					}
				}
				return array;
			},
			groupAndSumData(data) {
				const resultMap = new Map();

				data.forEach(item => {
					// 创建分组键：BatchCode + SellByDate第二个元素 + CommodityPriceType
					const key = `${item.batchCode}_${item.sellByDate[1]}_${item.commodityPriceType}`;

					if (!resultMap.has(key)) {
						// 如果不存在该分组，创建新分组
						resultMap.set(key, {
							batchCode: item.batchCode,
							accountBalance: item.stock,
							actualNumbers: item.stock,
							productDate: item.sellByDate[0],
							sellByDate: item.sellByDate[1], // 复制数组
							deficiency: 0,
							lossAmount: 0,
							depotId: item.depotId,
							depotName: item.depotName
						});
					} else {
						// 如果已存在该分组，累加Stock
						const existing = resultMap.get(key);
						existing.accountBalance += item.stock;
						existing.actualNumbers += item.stock;
					}
				});

				// 将Map转换为数组并返回
				return Array.from(resultMap.values());
			},
			initDepotData() {
				let self = this;
				request.get('/api/Depot/GetDepotList').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取仓库数据失败：" + response.errorMsg
						});
						return;
					}
					self.depotList = response.data;
				}).catch(function(error) {})
			},
			depotChange(val) {},
			submitValidate() {
				if (!this.documentItem.code) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "编号不可为空"
					});
					return false;
				}

				if (!this.documentItem.businessDate) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务日期"
					});
					return false;
				} else {}

				if (!this.documentItem.userId) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "请选择业务员"
					});
					return false;
				}

				if (this.documentItem.inventorySheetDetailLists.length <= 0) {
					this.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "您还没有选择商品"
					});
					return false;
				}
				return true;
			},
			dataSubmit() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				request.post('/api/InventorySheet/EditInventorySheet', self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}
					//记录商品盘点单操作
					var log = {
						FlowId: response.data,
						Title: '商品盘点单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此商品盘点单' : '创建了此商品盘点单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})
					//清空form规则检查
					self.emptyForm();
					self.$Notice.success({
						title: '正确提示',
						duration: 3,
						desc: '保存成功!'
					});
				}).catch(function(error) {})
			},
			dataSubmitAndCheck() {
				var validate = this.submitValidate();
				if (!validate) {
					return;
				}
				let self = this;
				let path = '';
				if (self.documentItem.id) {
					path = '/api/InventorySheet/EditInventorySheet';
				} else {
					path = '/api/InventorySheet/AddInventorySheet';
				}
				request.post(path, self.documentItem).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: '保存失败:' + response.errorMsg
						});
						return;
					}

					//记录商品盘点单操作
					var log = {
						FlowId: self.documentItem.id ? response.data : response.data.id,
						Title: '商品盘点单日志',
						OperationContent: self.documentItem.id > 0 ? '编辑了此商品盘点单' : '创建了此商品盘点单',
						Operator: parseInt(localStorage.getItem("userId")),
						State: 1,
						Creator: parseInt(localStorage.getItem("userId"))
					}
					request.post('/api/ProcessLog/AddProcessLog', [log]).then(function(response) {
						if (response.data.state == 0) {
							self.$Notice.error({
								title: '错误提示',
								duration: 3,
								desc: '日志记录失败:' + response.data.errorMsg
							});
							return;
						}
					}).catch(function(error) {})

					if (!self.documentItem.id) {
						self.documentItem = response.data;
					} else {
						self.documentItem.id = response.data;
					}
					self.checkInventorySheet(self.documentItem, '商品盘点单审核后不可更改，内容不可编辑，是否继续操作？');
				}).catch(function(error) {})
			},
			getNextCode() {
				let self = this;
				request.get('/api/InventorySheet/GetNextCode', {
					params: {
						prefix: 'PDD'
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}

					self.documentItem.code = response.data;
				}).catch(function(error) {})
			},
			rollback(ids) {
				if (ids.length < 1) {
					self.$Notice.error({
						title: '错误提示',
						duration: 3,
						desc: "没有选中记录！"
					});
					return;
				}
				let self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: '是否回滚到审核流程？',
					onOk() {
						request.post('/api/InventorySheet/Rollback', ids).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: "商品盘点单回滚失败：" + response.errorMsg
								});
								return;
							}

							var log = [];
							for (var i = 0; i < ids.length; i++) {
								//记录采购单操作
								log.push({
									FlowId: ids[i],
									Title: '商品盘点单日志',
									OperationContent: '回滚了此商品盘点单',
									Operator: parseInt(localStorage.getItem("userId")),
									State: 1,
									Creator: parseInt(localStorage.getItem("userId"))
								});
							}
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '回滚成功!'
							});
							self.getInventorySheet(ids[0]);
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			checkInventorySheet(data, func) {
				var self = this;
				this.$Modal.confirm({
					title: "操作警告",
					content: func,
					onOk() {
						request.post('/api/InventorySheet/CheckInventorySheet', [{
							id: data.id,
							state: 2
						}]).then(function(response) {
							if (response.state == 0) {
								self.$Notice.error({
									title: '错误提示',
									duration: 3,
									desc: response.errorMsg
								});
								return;
							}
							var log = [];
							//记录采购单操作
							log.push({
								FlowId: data.id,
								Title: '商品盘点单日志',
								OperationContent: '审核了此商品盘点单',
								Operator: parseInt(localStorage.getItem("userId")),
								State: 1,
								Creator: parseInt(localStorage.getItem("userId"))
							});
							request.post('/api/ProcessLog/AddProcessLog', log).then(function(response) {
								if (response.data.state == 0) {
									self.$Notice.error({
										title: '错误提示',
										duration: 3,
										desc: '日志记录失败:' + response.data.errorMsg
									});
									return;
								}
							}).catch(function(error) {})
							self.$Notice.success({
								title: '正确提示',
								duration: 3,
								desc: '审核成功!'
							});
							self.emptyForm();
						}).catch(function(error) {})
					},
					onCancel() {}
				});
			},
			initUserToSelect() { //初始化用户下拉框数据源
				let self = this;
				request.get('/api/User/GetUserToSelect').then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取数据失败：" + response.errorMsg
						});
						return;
					}
					self.userList = response.data;
				}).catch(function(error) {})
			},
			initPermission() {
				let self = this;
				let params = {
					funcCodes: ['InventorySheet.Add', 'InventorySheet.Edit', 'InventorySheet.Delete',
						'InventorySheet.Audit', 'InventorySheet.BatchAudit', 'InventorySheet.Print',
						'InventorySheet.Rollback', 'InventorySheet.Export', 'InventorySheet.BatchPrint'
					],
					userId: parseInt(localStorage.getItem("userId"))
				};
				request.post('/api/Function/VerifyPermissions', params).then(function(response) {
					let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if (tipTimeoutCount != undefined) {
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: "获取权限数据失败：" + response.errorMsg
						});
						return;
					} else if (response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)) {
						self.$Modal.warning({
							title: '系统到期提示',
							content: response.errorMsg,
							onOk: () => {
								localStorage.setItem("_tipTimeoutCount", 1);
							}
						});
					}
					if (tipTimeoutCount == undefined || tipTimeoutCount < 1000) {
						localStorage.setItem("_tipTimeoutCount", tipTimeoutCount == undefined ? 1 :
							tipTimeoutCount + 1)
					}
					for (var i = 0; i < response.data.length; i++) {
						switch (response.data[i].funcCode) {
							case 'InventorySheet.Add':
								self.permission.isAdd = response.data[i].permission
								break;
							case 'InventorySheet.Edit':
								self.permission.isEdit = response.data[i].permission
								break;
							case 'InventorySheet.Delete':
								self.permission.isDelete = response.data[i].permission
								break;
							case 'InventorySheet.Audit':
								self.permission.isAudit = response.data[i].permission
								break;
							case 'InventorySheet.BatchAudit':
								self.permission.isBatchAudit = response.data[i].permission
								break;
							case 'InventorySheet.Print':
								self.permission.isPrint = response.data[i].permission
								break;
							case 'InventorySheet.Rollback':
								self.permission.isRollback = response.data[i].permission
								break;
							case 'InventorySheet.Export':
								self.permission.isExport = response.data[i].permission
								break;
							case 'InventorySheet.BatchPrint':
								self.permission.isBatchPrint = response.data[i].permission
								break;
						}
					}
				}).catch(function(error) {})
			},
			packPrintData(data) {
				data.forEach((item, index) => {
					switch (item.checkState) {
						case 1:
							item.checkState = '已创建'
							break;
						case 2:
							item.checkState = '已审核'
							break;
						case 3:
							item.checkState = '已完结'
							break;
					}
					item.businessDate = item.businessDate.replace(' 00:00:00', '');
				})
				let selectedReceiptData = {
					name: 'inventorySheet',
					title: '商品盘点单',
					attributes: ['baseFieldItem', 'inventorySheetDetailLists'],
					receipts: data,
					baseFieldItem: [{
							name: 'code',
							displayName: '单据编号'
						},
						{
							name: 'userDisplayName',
							displayName: '业务员'
						},
						{
							name: 'businessDate',
							displayName: '业务日期'
						},
						{
							name: 'lossAmount',
							displayName: '盈亏额'
						},
						{
							name: 'lossQuantity',
							displayName: '盈亏数量'
						},
						{
							name: 'note',
							displayName: '备注'
						},
						{
							name: 'checkState',
							displayName: '单据状态'
						}
					],
					inventorySheetDetailLists: [{
							name: 'commodityName',
							displayName: '商品名'
						}, {
							name: 'format',
							displayName: '规格'
						},
						{
							name: 'unit',
							displayName: '商品单位'
						},
						{
							name: 'price',
							displayName: '采购价'
						},
						{
							name: 'accountBalance',
							displayName: '帐存数'
						},
						{
							name: 'actualNumbers',
							displayName: '实际数'
						},
						{
							name: 'deficiency',
							displayName: '盈亏数'
						},
						{
							name: 'lossAmount',
							displayName: '盈亏额'
						},
						{
							name: 'note',
							displayName: '备注'
						}
					]
				}
				localStorage.setItem('_printData', JSON.stringify(selectedReceiptData));
				this.$router.push({
					path: 'printerpage'
				});
			},
			printList() {
				this.packPrintData([this.documentItem]);
			},
			getInventorySheet(inventorySheetId) {
				let self = this;
				request.get('/api/InventorySheet/GetInventorySheetPriceType', {
					params: {
						id: inventorySheetId
					}
				}).then(function(response) {
					if (response.state == 0) {
						self.$Notice.error({
							title: '错误提示',
							duration: 3,
							desc: response.errorMsg
						});
						return;
					}
					self.initInventorySheet(response.data);
				}).catch(function(error) {})
			},
			initInventorySheet(data) {
				this.documentItem = data;
			},
			countAmount() {
				this.documentItem.lossAmount = 0;
				this.documentItem.lossQuantity = 0;
				this.documentItem.inventorySheetDetailLists.forEach((element) => {
					this.documentItem.lossAmount += element.lossAmount;
					this.documentItem.lossQuantity += element.deficiency;
				});
				this.documentItem.lossAmount = formatNum(this.documentItem.lossAmount);
				this.documentItem.lossQuantity = formatNum(this.documentItem.lossQuantity);
			}
		},
		watch: {
			'$route.query.inventorySheetId': {
				immediate: true,
				handler(param) {
					if (param) {
						this.getInventorySheet(param);
					} else {
						this.emptyForm();
					}
				}
			},
			'documentItem.inventorySheetDetailLists': {
				deep: true,
				handler(arr) {
					this.countAmount();
				}
			}
		},
		created: function() {
			this.emptyForm();
			this.initPermission();
			this.initUserToSelect();
			this.initDepotData();
			this.initDebounce();
			this.$nextTick(() => {
				let contentElement = document.querySelector(".main-content");
				this.pageHeight = contentElement ? contentElement.offsetHeight - 100 : 700;
			})
		}
	}
</script>

<style scoped>
	.layout {
		border-radius: 8px;
	}

	.tool-box {
		padding: 10px;
		background-color: #fff;
		overflow: hidden;
		border-left: 5px solid rgb(255, 106, 127);
		margin-bottom: 10px;
	}

	.tool-box Button {
		margin-left: 10px;
		float: right;
	}

	.tool-box-title {
		float: left;
		font-size: 16px;
		color: black;
		height: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.baseInfo {
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.baseinfo-table {
		width: 100%;
		background-color: #fff;
		color: #666;
		border-collapse: collapse;
	}

	.baseinfo-table td,
	.baseinfo-table th {
		position: relative;
		padding: 9px 15px;
		min-height: 20px;
		line-height: 20px;
		font-size: 14px;
		border-width: 1px;
		border-style: solid;
		border-color: #e6e6e6;
	}


	.baseinfo-input {
		border: none;
		outline: none;
		height: 15px;
		padding-left: 0px;
		width: 100%;
	}

	.commodityInfo {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.file {
		margin-top: 10px;
		background-color: #fff;
		border-radius: 5px;
		padding: 10px 10px;
	}

	.modal-title {
		overflow: hidden;
		padding-bottom: 10px;
		font-size: 16px;
	}

	.layout-title-left {
		float: left;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.layout-title-right {
		float: right;
	}

	.selectBox /deep/ div {
		border: none !important;
	}

	.discount-label {
		display: inline-block;
		text-align: center;
		width: 29%;
	}

	#voucher-bottomBar {
		background-color: antiquewhite;
		padding: 7.5px 22px 0px 10px;
		box-shadow: 0 -1px 6pxrgba(0, 0, 0, .15);
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: auto !important;
		padding: 12px 30px !important;
	}

	.billStateCls {
		width: 100px;
		height: 50px;
		line-height: 50px;
		font-size: 16px;
		position: absolute;
		top: 100px;
		left: 200px;
		border: solid 2px red;
		color: red;
		font-weight: 600;
		-webkit-transform: rotate(-30deg);
		transform: rotate(-30deg);
		z-index: 19999;
	}
</style>